import { apiService } from '../api';

/**
 * Wraps the /api/admission-enrollment surface — the handover from
 * AdmissionApplication to Student + Enrollment. Preview is read-only; batch
 * is the atomic per-application write (see
 * backend/src/controllers/admissions/admissionEnrollmentController.ts).
 */

/** A section of the applicant's class, with its seats filled so far. */
export interface HandoverSection {
  _id: string;
  name: string;
  capacity: number | null;
  enrolled: number;
}

export interface HandoverPreviewRow {
  applicationId: string;
  name: string;
  applicationNumber: string;
  /** Only a returning student has one before the handover. */
  grNumber?: string;
  class?: { _id: string; name: string } | string;
  /** The class's sections this session; empty when it has none. */
  sections: HandoverSection[];
  ready: boolean;
  blockers: string[];
}

export interface HandoverPreviewResponse {
  summary: { total: number; ready: number; blocked: number };
  items: HandoverPreviewRow[];
}

export interface HandoverRowResult {
  applicationId: string;
  outcome: 'enrolled' | 'skipped' | 'failed';
  reason?: string;
  studentId?: string;
  enrollmentId?: string;
  grNumber?: string;
  rollNumber?: number;
}

export interface HandoverBatchResponse {
  summary: { total: number; enrolled: number; skipped: number; failed: number };
  results: HandoverRowResult[];
}

export const handoverService = {
  preview: async (params?: { cycleId?: string }): Promise<HandoverPreviewResponse> => {
    const r = await apiService.get<HandoverPreviewResponse>('/admission-enrollment/preview', params);
    return r.data!;
  },

  /** `sections` maps applicationId → section, for classes that have sections. */
  batch: async (applicationIds: string[], sections: Record<string, string>): Promise<HandoverBatchResponse> => {
    const r = await apiService.post<HandoverBatchResponse>('/admission-enrollment/batch', { applicationIds, sections });
    return r.data!;
  },
};
